module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-login-5"
  }, [_c('div', {
    staticClass: "row bs-reset"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3 login-container"
  }, [_c('img', {
    staticClass: "login-logo login-6",
    attrs: {
      "src": "/static/pages/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLogin),
      expression: "showLogin"
    }],
    staticClass: "login-form",
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getConfirmation && _vm.logErr),
      expression: "getConfirmation && logErr"
    }],
    staticClass: "alert alert-success"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Your account has been activated successfully. You can now login.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getLoginError != ''),
      expression: "getLoginError != ''"
    }],
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getLoginError))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control form-control-solid placeholder-no-fix form-group",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Email Address",
      "name": "username",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSubmit.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control form-control-solid placeholder-no-fix form-group",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "Password",
      "name": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSubmit.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-4 col-sm-8 text-right"
  }, [_c('div', {
    staticClass: "forgot-password"
  }, [_c('a', {
    staticClass: "forget-password",
    staticStyle: {
      "color": "#d09f23!important",
      "font-size": "15px"
    },
    attrs: {
      "id": "forget-password"
    },
    on: {
      "click": _vm.showRemind
    }
  }, [_vm._v("Forgot Password?")])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.remindPassword),
      expression: "remindPassword"
    }],
    staticClass: "forget-form",
    attrs: {
      "action": "javascript:;",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onForgotSubmit.apply(null, arguments)
      }
    }
  }, [_c('h3', [_vm._v("Forgot Password ?")]), _vm._v(" "), _c('p', [_vm._v(" Enter your e-mail address below to reset your password. ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forgotEmail),
      expression: "forgotEmail"
    }],
    staticClass: "form-control placeholder-no-fix",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.forgotEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.forgotEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "btn blue btn-outline",
    attrs: {
      "type": "button",
      "id": "back-btn"
    },
    on: {
      "click": _vm.hideRemind
    }
  }, [_vm._v("Back")]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "login-footer"
  }, [_c('div', {
    staticClass: "row bs-reset"
  }, [_c('div', {
    staticClass: "col-md12 bs-reset"
  }, [_c('div', {
    staticClass: "login-copyright text-left"
  }, [_c('p', [_vm._v("© " + _vm._s(_vm.getCurrentYear) + " CaseMGR Solutions, Inc. All Rights Reserved.")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn blue mt-ladda-btn ladda-button sign-in-btn",
    attrs: {
      "type": "submit",
      "data-style": "expand-left"
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Sign In")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn blue pull-right mt-ladda-btn ladda-button forgot-password-btn",
    attrs: {
      "type": "submit",
      "data-style": "expand-left"
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Submit")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17278b58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 1568
// module chunks = 1